import Tab, { tabClasses } from "@mui/joy/Tab";
import {
  Box,
  Button,
  CircularProgress,
  createTheme,
  Paper,
  SwipeableDrawer,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  ThemeProvider,
} from "@mui/material";
import axios from "axios";
import React, { Fragment, useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./orders.styles.scss";

import { TabList, Tabs } from "@mui/joy";
import PaymentModal from "./paymentModel.component";
import PaymentSettlementModal from "./paymentSettlement.component";
import SettlementModal from "./settlementModel.component";

const theme = createTheme({
  palette: {
    primary: {
      main: "#a36e29",
    },
  },
  typography: {
    fontFamily: '"Work Sans", sans-serif',
  },

  background: {
    paper: "#a36e29",
  },
  text: {
    primary: "#a36e29",
    secondary: "#a36e29",
  },
  action: {
    active: "#a36e29",
  },
  success: {
    dark: "#a36e29",
  },
});

const PaymentsComponent = ({ row }) => {
  const admin = JSON.parse(localStorage.getItem("admin"));
  const [ordersList, setOrdersList] = useState([]);

  const [paymentList, setPaymentList] = useState([]);
  const [selectedPaymentId, setSelectedPaymentId] = useState();
  const [settlementList, setSettlementList] = useState([]);
  const [refundList, setRefundList] = useState([]);
  const [showDataLoading, setShowDataLoading] = useState(true);
  const [selectedSellerId, setSelectedSellerId] = useState("");
  const [unSettledPaymentList, setUnSettledPaymentList] = useState([]);

  useEffect(() => {
    (async () => {
      if (!admin.token) return;
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_URL}v1.0.0/admin/settlements/settlements.php?type=payments`,
        {
          headers: {
            Authorization: `Bearer ${admin.token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      setOrdersList(data?.response?.payment_list);
      setPaymentList(
        data?.response?.payment_list.sort((a, b) => {
          return new Date(b.updated_at) - new Date(a.updated_at);
        })
      );

      const { data: settlementData } = await axios.get(
        `${process.env.REACT_APP_API_URL}v1.0.0/admin/settlements/settlements.php?type=settlements`,
        {
          headers: {
            Authorization: `Bearer ${admin.token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      setShowDataLoading(false);
      setSettlementList(
        settlementData?.response?.settlement_list.sort((a, b) => {
          return new Date(b.updated_at) - new Date(a.updated_at);
        })
      );
      setRefundList([]);

      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}v1.0.0/admin/settlements/settlements.php?type=unsettled_sellers`,
        {
          headers: {
            Authorization: `Bearer ${admin.token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      const unsettledPaymentMap = {};
      response?.data?.response &&
        Object.entries(response.data.response).forEach(([_, payments]) => {
          const companyName = payments[0]?.seller_details?.company_name;
          if (companyName) {
            unsettledPaymentMap[companyName] = payments;
          }
        });

      setUnSettledPaymentList(unsettledPaymentMap);
    })();
  }, []);

  const [openSettlementModal, setOpenSettlementModal] = useState(false);

  const [showLoading, setShowLoading] = useState(false);

  const [page, setPage] = useState(0);

  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [showDrawer, setShowDrawer] = useState(false);

  const handleChangePage = (_, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const [selectedTab, setSelectedTab] = useState(0);

  const [modalOpen, setModalOpen] = useState(false);

  return (
    <div className="category-component">
      <ToastContainer />

      {/* Swipable Drawer */}
      <ThemeProvider theme={theme}>
        <SwipeableDrawer
          anchor="right"
          open={showDrawer}
          onClose={() => {
            setShowLoading(false);

            setShowDrawer(false);
          }}
          onOpen={() => setShowDrawer(true)}
        ></SwipeableDrawer>
      </ThemeProvider>

      {/* Main Content */}
      <div className="head">
        <div className="head-txt">Payments</div>
      </div>

      <div>
        {selectedTab === 0 && (
          <PaymentModal
            modalOpen={modalOpen}
            setModalOpen={setModalOpen}
            selectedPaymentId={selectedPaymentId}
          />
        )}
        {selectedTab === 1 &&
          modalOpen &&
          selectedPaymentId &&
          selectedSellerId && (
            <SettlementModal
              modalOpen={modalOpen}
              setModalOpen={setModalOpen}
              sellerId={selectedSellerId}
              selectedPaymentId={selectedPaymentId}
            />
          )}
        <PaymentSettlementModal
          modalOpen={openSettlementModal}
          setModalOpen={setOpenSettlementModal}
          unSettledPaymentList={unSettledPaymentList}
        />
      </div>
      <Box
        sx={{
          width: "95%",
          marginLeft: "40px",
          marginRight: "auto",
          marginBottom: "50px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Tabs
          aria-label="tabs"
          defaultValue={0}
          onChange={(_, value) => {
            console.log(value);
            setSelectedTab(value);
            if (value === 0) {
              setOrdersList(paymentList);
            }
            if (value === 1) {
              setOrdersList(settlementList);
            }
            if (value === 2) {
              setOrdersList(refundList);
            }
          }}
          sx={{
            bgcolor: "transparent",
            borderColor: "green",
          }}
        >
          <TabList
            disableUnderline
            sx={{
              p: 0.5,

              gap: 0,
              borderRadius: "xl",
              [`& .${tabClasses.root}[aria-selected="true"]`]: {
                boxShadow: "sm",
                bgcolor: "background.surface",
                border: "2px solid brown",
              },
            }}
          >
            <Tab
              value={0}
              disableIndicator
              style={{
                minWidth: "300px",
                borderRadius: "5px",
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                border:
                  selectedTab === 0 ? "2px solid #A36E29" : "2px solid #BEBEBE",
              }}
            >
              <p
                style={{
                  fontWeight: 550,
                  color: selectedTab === 0 ? "#A36E29" : "gray",
                }}
              >
                Payment
              </p>
            </Tab>
            <Tab
              value={1}
              disableIndicator
              style={{
                minWidth: "300px",
                borderRadius: 0,
                border:
                  selectedTab === 1 ? "2px solid #A36E29" : "2px solid #BEBEBE",
              }}
            >
              <p
                style={{
                  fontWeight: 550,
                  color: selectedTab === 1 ? "#A36E29" : "gray",
                }}
              >
                Settlement
              </p>
            </Tab>
            <Tab
              value={2}
              disableIndicator
              style={{
                minWidth: "300px",
                borderRadius: 0,
                border:
                  selectedTab === 2 ? "2px solid #A36E29" : "2px solid #BEBEBE",
              }}
            >
              <p
                style={{
                  fontWeight: 550,
                  color: selectedTab === 2 ? "#A36E29" : "gray",
                }}
              >
                {" "}
                Refund
              </p>
            </Tab>
          </TabList>
        </Tabs>
        {selectedTab === 1 ? (
          <Button
            style={{
              width: "max-content",
              paddingLeft: "60px",
              paddingRight: "60px",
              fontWeight: 600,
              height: "60px",
              backgroundColor: "#a36e29",
              color: "white",
            }}
            onClick={() => setOpenSettlementModal(true)}
          >
            {" "}
            Settle Payment
          </Button>
        ) : null}
      </Box>

      <ThemeProvider theme={theme}>
        <Paper style={{ width: "95%", overflow: "hidden", margin: "auto" }}>
          {showDataLoading ? (
            <CircularProgress
              style={{
                margin: "auto",
                display: "flex",
                height: "100%",
              }}
            />
          ) : (
            <TableContainer
              style={{
                height: "70%",
              }}
            >
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  {selectedTab === 0 ? (
                    <TableRow>
                      <TableCell>Date</TableCell>
                      <TableCell>Payment Id</TableCell>
                      <TableCell>Order Id</TableCell>
                      <TableCell>Total Price</TableCell>
                      <TableCell>Status</TableCell>
                    </TableRow>
                  ) : (
                    <TableRow>
                      <TableCell>Date</TableCell>
                      <TableCell>Settlement Id</TableCell>
                      <TableCell>Settlement Amount</TableCell>
                      <TableCell>Total Amount</TableCell>
                    </TableRow>
                  )}
                </TableHead>
                <TableBody>
                  {ordersList?.length > 0 &&
                    ordersList
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      ?.map((row) => {
                        return (
                          <Fragment key={row.id}>
                            {selectedTab === 0 ? (
                              <TableRow
                                hover
                                role="checkbox"
                                tabIndex={-1}
                                key={row.id}
                                onClick={() => {
                                  console.log("row", row);
                                  if (selectedTab === 1) {
                                    setSelectedPaymentId(
                                      row?.settlement_public_id
                                    );
                                    setSelectedSellerId(row.seller_id);
                                  } else {
                                    setSelectedPaymentId(row?.order_record_id);
                                  }
                                  setModalOpen(true);
                                }}
                              >
                                <TableCell>{row?.updated_at}</TableCell>
                                <TableCell>{row?.payment_public_id}</TableCell>
                                <TableCell>{row?.order_id}</TableCell>
                                <TableCell>{row?.settlement_amount}</TableCell>
                                <TableCell
                                  style={{
                                    fontWeight: 800,
                                    color:
                                      row?.settlement_status !== "NOT_SETTLED"
                                        ? "green"
                                        : "gray",
                                  }}
                                >
                                  {row?.settlement_status}
                                </TableCell>
                              </TableRow>
                            ) : (
                              <TableRow
                                hover
                                role="checkbox"
                                tabIndex={-1}
                                key={row.id}
                                onClick={() => {
                                  console.log("row", row);
                                  if (selectedTab === 1) {
                                    setSelectedPaymentId(
                                      row?.settlement_public_id
                                    );
                                    setSelectedSellerId(row.seller_id);
                                  } else {
                                    setSelectedPaymentId(row?.order_record_id);
                                  }
                                  setModalOpen(true);
                                }}
                              >
                                <TableCell>{row?.updated_at}</TableCell>
                                <TableCell>
                                  {row?.settlement_public_id}
                                </TableCell>
                                <TableCell>{row?.settlement_amount}</TableCell>
                                <TableCell>{row?.total_amount}</TableCell>
                              </TableRow>
                            )}
                          </Fragment>
                        );
                      })}
                </TableBody>
              </Table>
            </TableContainer>
          )}
          <TablePagination
            style={{ marginTop: "auto" }}
            rowsPerPageOptions={[25, 50, 100, 200]}
            component="div"
            count={ordersList?.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </ThemeProvider>
    </div>
  );
};

export default PaymentsComponent;
